// ---------------------------------------------------------------------------
// Sprint 7 A1: Deal Momentum Badge
// ---------------------------------------------------------------------------
// Displays 🔥 (accelerating), ⏳ (stable), ❄️ (decelerating) with tooltip.
// Used on pipeline board deal cards AND "Here's Your Money" daily view.

interface DealMomentumBadgeProps {
  direction: "accelerating" | "stable" | "decelerating";
  score?: number; // 0-100 momentum score
  factors?: Array<{ name: string; description: string }>;
  compact?: boolean; // true = emoji only, false = emoji + label
}

const MOMENTUM_CONFIG = {
  accelerating: {
    emoji: "🔥",
    label: "Accelerating",
    color: "text-[var(--color-success)] bg-[var(--color-success)]/5 border-[var(--color-success)]/20",
    description: "Deal is gaining momentum",
  },
  stable: {
    emoji: "⏳",
    label: "Stable",
    color: "text-[var(--color-warning)] bg-[var(--color-warning)]/5 border-[var(--color-warning)]/20",
    description: "Deal momentum is steady",
  },
  decelerating: {
    emoji: "❄️",
    label: "Decelerating",
    color: "text-[var(--color-primary)] bg-[var(--color-primary)]/5 border-[var(--color-primary)]/20",
    description: "Deal is losing momentum",
  },
} as const;

export function DealMomentumBadge({ direction, score, compact = false }: DealMomentumBadgeProps) {
  const config = MOMENTUM_CONFIG[direction];

  if (compact) {
    return (
      <span
        className="inline-flex items-center cursor-default"
        title={`${config.label}${score != null ? ` (${score}/100)` : ""}`}
      >
        {config.emoji}
      </span>
    );
  }

  return (
    <div className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-xs font-medium ${config.color}`}>
      <span>{config.emoji}</span>
      <span>{config.label}</span>
      {score != null && (
        <span className="text-xs opacity-70">{score}</span>
      )}
    </div>
  );
}

